import { useContext } from "react";

import { ClientConfigContext } from "./ClientConfigContext.shared";

/**
 * Hook to access client configuration from context
 *
 * @returns Client config context value
 * @throws Error if used outside ClientConfigProvider
 */
export const useClientConfig = () => {
  const context = useContext(ClientConfigContext);

  if (context === undefined) {
    throw new Error(
      "useClientConfig must be used within a ClientConfigProvider"
    );
  }

  return context;
};
